import { createFileRoute } from '@tanstack/react-router';
import { CampaignExperimentDetailRoute } from './-route-wrappers';

function CampaignsOverviewTestsExperimentRoute() {
  const { campaignId, experimentId } = Route.useParams();

  return <CampaignExperimentDetailRoute campaignId={campaignId} experimentId={experimentId} campaignPath="campaigns" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/experiments/$experimentId',
)({
  component: CampaignsOverviewTestsExperimentRoute,
});
